/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of an organizational unit node
 * @export
 * @interface B2BUnitNode
 */
export interface B2BUnitNode {
    /**
     * Identifier of the organizational unit represented by the node
     * @type {string}
     * @memberof B2BUnitNode
     */
    id: string;
    /**
     * Name of the organizational unit represented by the node
     * @type {string}
     * @memberof B2BUnitNode
     */
    name?: string;
    /**
     * Unique identifier of organizational unit node's parent unit
     * @type {string}
     * @memberof B2BUnitNode
     */
    parent?: string;
    /**
     * Boolean flag of whether organizational unit represented by the node is active
     * @type {boolean}
     * @memberof B2BUnitNode
     */
    active?: boolean;
    /**
     * Child nodes of the organizational unit node
     * @type {Array<B2BUnitNode>}
     * @memberof B2BUnitNode
     */
    children?: Array<B2BUnitNode>;
    /**
     * Description of the organizational unit represented by the node
     * @type {string}
     * @memberof B2BUnitNode
     */
    description?: string;
    /**
     * Localized Name of the organizational unit represented by the node
     * @type {string}
     * @memberof B2BUnitNode
     */
    localizedName?: string;
    /**
     * Boolean flag of default B2BUnit of the given User.
     * @type {boolean}
     * @memberof B2BUnitNode
     */
    defaultForUser?: boolean;
}

/**
 * Check if a given object implements the B2BUnitNode interface.
 */
export function instanceOfB2BUnitNode(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function B2BUnitNodeFromJSON(json: any): B2BUnitNode {
    return B2BUnitNodeFromJSONTyped(json, false);
}

export function B2BUnitNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BUnitNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'children': !exists(json, 'children') ? undefined : ((json['children'] as Array<any>).map(B2BUnitNodeFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'localizedName': !exists(json, 'localizedName') ? undefined : json['localizedName'],
        'defaultForUser': !exists(json, 'defaultForUser') ? undefined : json['defaultForUser'],
    };
}

export function B2BUnitNodeToJSON(value?: B2BUnitNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'parent': value.parent,
        'active': value.active,
        'children': value.children === undefined ? undefined : ((value.children as Array<any>).map(B2BUnitNodeToJSON)),
        'description': value.description,
        'localizedName': value.localizedName,
        'defaultForUser': value.defaultForUser,
    };
}

